import { FormControl, FormLabel, Input, Text, VStack } from '@chakra-ui/react'

interface Props {
  firstName: string
  lastName: string
  userDetailMissing: boolean
}

const StepPlayerCoachForm = ({ firstName, lastName, userDetailMissing }: Props) => (
  <VStack spacing={4} align="stretch">
    {userDetailMissing && (
      <Text color="orange.300" fontSize="sm">
        Account info not loaded — please retry in a moment.
      </Text>
    )}
    <FormControl>
      <FormLabel color="whiteAlpha.800" fontSize="sm">First name</FormLabel>
      <Input isDisabled value={firstName} color="white" bg="whiteAlpha.100" borderColor="whiteAlpha.300" />
    </FormControl>
    <FormControl>
      <FormLabel color="whiteAlpha.800" fontSize="sm">Last name</FormLabel>
      <Input isDisabled value={lastName} color="white" bg="whiteAlpha.100" borderColor="whiteAlpha.300" />
    </FormControl>
  </VStack>
)

export default StepPlayerCoachForm
